import React from 'react'
import { LoadingButton } from '@mui/lab'
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography
} from '@mui/material'
import MenuClose from 'assets/icons/MenuClose.png'
import { RoundedButton } from 'common/Button/Button'

interface WinbackConfirmDialogProps {
  showWinbackConfirmDialog: boolean
  handleDialogClose: () => void
  handleConfirm: () => void
  onCancelClick: () => void
  winbackSummary: string
  winbackTotalAmount: string
  loading: boolean
  handleBack: () => void
  months: number
  title: string
}
const WinbackConfirmDialog = ({
  showWinbackConfirmDialog,
  handleConfirm,
  onCancelClick,
  winbackSummary,
  winbackTotalAmount,
  loading,
  handleBack,
  months,
  title
}: WinbackConfirmDialogProps) => {
  return (
    <>
      <Dialog
        open={showWinbackConfirmDialog}
        maxWidth='lg'
        onClose={() => {
          {
            onCancelClick()
          }
        }}
      >
        <Box sx={{ minHeight: '450px', minWidth: '384px' }}>
          <DialogTitle>
            <Stack
              sx={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between'
              }}
            >
              <Typography
                sx={{
                  fontSize: '24px',
                  fontWeight: '700',
                  color: '#151D29',
                  mx: '0px'
                }}
              >
                Confirm {title}
              </Typography>
              <IconButton
                onClick={() => {
                  onCancelClick()
                }}
                size='small'
                data-cy='closeDialogBtn'
                sx={{
                  mr: '-10px',
                  mt: '-5px',
                  width: '40px',
                  height: '40px'
                }}
              >
                <img
                  style={{
                    width: '20px',
                    height: 'auto'
                  }}
                  src={MenuClose}
                />
              </IconButton>
            </Stack>
          </DialogTitle>
          <DialogContent>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              <Stack
                sx={{
                  display: 'flex',
                  flexDirection: 'column'
                }}
              >
                <Typography
                  textAlign='left'
                  sx={{ color: '#818D9C', fontSize: '18px', mb: '-6px' }}
                >
                  Summary
                </Typography>
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    mb: '24px'
                  }}
                >
                  <Typography textAlign='left' sx={{ color: '#151D29' }}>
                    {winbackSummary}{' '}
                    {winbackSummary === 'Bill Waiver' ? `x ${months}` : ''}
                  </Typography>
                  <Typography textAlign='left' sx={{ color: '#151D29' }}>
                    {winbackTotalAmount}
                  </Typography>
                </Stack>
                <Divider sx={{ width: '100%', mb: '16px' }} />
                <Stack
                  sx={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                    mb: '16px'
                  }}
                >
                  <Typography
                    sx={{ fontWeight: 700, color: '#151D29', fontSize: '18px' }}
                  >
                    Total amount
                  </Typography>
                  <Typography
                    sx={{ fontWeight: 700, color: '#151D29', fontSize: '18px' }}
                  >
                    {winbackTotalAmount}
                  </Typography>
                </Stack>
                <Divider sx={{ width: '100%' }} />
              </Stack>
            </Box>
          </DialogContent>
          <Stack
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              margin: '100px 16px 15px 0'
            }}
          >
            <RoundedButton sx={{ padding: '10px 40px' }} onClick={handleBack}>
              Back
            </RoundedButton>
            <LoadingButton
              variant='filled'
              loading={loading}
              loadingIndicator='Processing...'
              onClick={handleConfirm}
              sx={{ padding: '10px 27px' }}
            >
              Confirm
            </LoadingButton>
          </Stack>
        </Box>
      </Dialog>
    </>
  )
}

export default WinbackConfirmDialog
